import { ax } from "@src/utils/axios/axios";
import { BASE_API_URL } from "@src/constants";
import { RoleId } from "@src/types/common/RoleId";

interface FetchOptions {
  drsSummaryId?: string;
  regionId?: string;
  depotPayroll?: string;
  start: string;
  end: string;
}

export const apiDRSOvertimeFetch = ({ drsSummaryId, regionId, depotPayroll, start, end }: FetchOptions) => {
  const params: any = {
    start,
    end,
    reqRole: RoleId.ProjectManager,
    reqDev: "web",
  };

  if (drsSummaryId) params.drsSummaryId = drsSummaryId;
  if (regionId) params.regionId = regionId;
  if (depotPayroll) params.depotPayroll = depotPayroll;

  return ax({
    method: "GET",
    url: `${BASE_API_URL}/labour`,
    params,
  });
};
